 // ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
    sendChatBotEvent(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  window._conv_q = window._conv_q || [];
  _conv_q.push(["pushRevenue", params.totalPrice, params.itemCount, "100032237"]);
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

async function sendOrderDetails(order_details) {
  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
  // todo validate that this cookie id will be accessible
  const uid = getCookie("verifast-session-id");
  const { shop_domain, orderNumber } = order_details;

  try {
    const response = await fetch(
      `https://events.verifast.ai/webhook-endpoint/conversion/quick_checkout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          index_name: shop_domain,
          session_id: uid,
          order_number: orderNumber,
          uf_name: "shopify_order_details",
          uf_val: JSON.stringify({
            index_name: shop_domain,
            order_number: orderNumber,
            event_time: new Date().toISOString(),
          }),
        }),
      }
    );
    const data = await response.json();
    console.log(data);
  } catch (error) {
    console.error("Error:", error);
  }
}

async function sendChatBotEvents(params) {
  try {
    const domain = "https://decodeage.com/";
    const orderNumber = document
      .getElementsByClassName("os-order-number")[0]
      .textContent.trim();
    const numericOrderNumber = +orderNumber.match(/\d+/)[0];

    const exampleOrderDetails = {
      shop_domain: "https://decodeage.com/",
      orderNumber: params.shopOrderId,
    };
    const orderDetailsLog = JSON.stringify(exampleOrderDetails);
    // Conversion scripts you want to run only once
    sendOrderDetails(exampleOrderDetails);
  } catch (e) {
    console.log(`Failure during sending payload to verifast ${e}`);
  }
// Manually constructing the exampleOrderDetails object
}